import { useState } from 'react'
import { DELETE_WISHLIST } from '../graphql/deleteWishlist'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { useWishlist } from './use-wishlist'
import { useRouter } from 'next/router'

export interface DeleteWishlistInputVariable {
    id: number
}

export interface OutputInterface {
    deleteWishlist: {
        status: boolean
    }
}

export interface UseDeleteWishlistOutputInterface {
    deleteWishlist: (
        formInput: DeleteWishlistInputVariable
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
    isLoading: boolean
}

export const useDeleteWishlist = (): UseDeleteWishlistOutputInterface => {
    const { mutate } = useWishlist()
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()

    const deleteWishlist = async (formInput: DeleteWishlistInputVariable) => {
        setIsLoading(true)
        const response = await graphqlFetch<
            { wishlistId: number },
            OutputInterface
        >({
            query: DELETE_WISHLIST,
            variables: { wishlistId: formInput?.id },
            locale
        })

        //check if mutate the wishlist list can be updated without request
        await mutate()
        setIsLoading(false)
        return response
    }

    return {
        isLoading,
        deleteWishlist
    }
}
